<template>
  <div class="log-analyze-viewer">
    <div class="log-analyze-viewer-title">
      <p class="log-analyze-viewer-title-text">字段索引属性</p>
      <el-button type="text" @click="onAddConfig('create')">+&nbsp;新增</el-button>
    </div>
    <el-table
      class="log-analyze-viewer-table"
      :data="analyzeData"
      style="width: 100%"
      :default-expand-all="true"
      :row-class-name="getRowClass"
    >
      <el-table-column type="expand">
        <template #default="scope">
          <el-table :data="scope.row.analysisConfigDtoList" style="width: 100%">
            <el-table-column width="48"> </el-table-column>
            <el-table-column prop="fieldName" label="字段名称">
              <template #default="scope">
                <ellipsis-card
                  :title="scope.row.fieldName"
                  :keyword="scope.row.fieldName"
                ></ellipsis-card>
              </template>
            </el-table-column>
            <el-table-column prop="fieldType" label="类型"> </el-table-column>
            <el-table-column prop="alias" label="别名">
              <template #default="scope">
                <ellipsis-card
                  :title="scope.row.alias"
                  v-if="scope.row.fieldType !== 'json'"
                  :keyword="scope.row.alias"
                ></ellipsis-card>
                <p v-else>——</p>
              </template>
            </el-table-column>
            <el-table-column prop="openStatistics" label="开启统计">
              <template #default="scope">
                <p v-if="scope.row.fieldType !== 'json'">
                  {{ scope.row.openStatistics ? '是' : '否' }}
                </p>
                <p v-else>——</p>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template #default="props">
                <div v-if="!scope.row.id">
                  <el-button @click="onDeleteChildAnalyze(scope, props)">删除</el-button>
                  <el-button type="primary" @click="onEditChildAnalyze(scope, props)"
                    >编辑</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="fieldName">
        <template slot="header">
          字段名称
          <el-popover
            placement="top-start"
            title="说明"
            width="200"
            trigger="hover"
            content="实际数据字段名称"
          >
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </template>
        <template #default="scope">
          <ellipsis-card
            :title="scope.row.fieldName"
            :keyword="scope.row.fieldName"
          ></ellipsis-card>
        </template>
      </el-table-column>
      <el-table-column prop="fieldType">
        <template slot="header">
          类型
          <el-popover
            placement="top-start"
            title="说明"
            width="200"
            trigger="hover"
            content="数据类型"
          >
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="alias">
        <template slot="header">
          别名
          <el-popover
            placement="top-start"
            title="说明"
            width="200"
            trigger="hover"
            content="可以为字段名称指定一个别名"
          >
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </template>
        <template #default="scope">
          <ellipsis-card
            :title="scope.row.alias"
            v-if="scope.row.fieldType !== 'json'"
            :keyword="scope.row.alias"
          ></ellipsis-card>
          <p v-else>——</p>
        </template>
      </el-table-column>
      <el-table-column prop="openStatistics">
        <template slot="header">
          开启统计
          <el-popover
            placement="top-start"
            title="说明"
            width="200"
            trigger="hover"
            content="选择开启统计，搜索时中文将按照全部匹配搜索"
          >
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </template>
        <template #default="scope">
          <p v-if="scope.row.fieldType !== 'json'">
            {{ scope.row.openStatistics ? '是' : '否' }}
          </p>
          <p v-else>——</p>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template #default="scope">
          <div v-if="!scope.row.id">
            <el-button @click="onDeleteAnalyze(scope)">删除</el-button>
            <el-button type="primary" @click="onEditAnalyze(scope)">编辑</el-button>
            <el-button
              v-if="scope.row.fieldType.toLowerCase() === 'json'"
              type="primary"
              @click="onAddAnalyzeChild(scope)"
              >新增</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <analyze-config-creator-and-editor
      ref="analyzeConfigCreatorAndEditor"
      @submit="handleAnalyzeSaved"
    ></analyze-config-creator-and-editor>
  </div>
</template>

<script>
import { reqFetchAnalysis, reqFetchCommonConfig } from '@/api/config';
import { reqFetchDataSource } from '@/api/log';
import EllipsisCard from '../common/EllipsisCard';
import AnalyzeConfigCreatorAndEditor from './AnalyzeConfigCreatorAndEditor';

export default {
  name: 'AnalyzeTableViewer',

  components: {
    EllipsisCard,
    AnalyzeConfigCreatorAndEditor
  },

  props: {
    datasource: {
      type: Object
    }
  },

  data() {
    return {
      analyzeData: [],
      defaultConfigs: ['cdn', 'mysql'],
      logId: JSON.parse(sessionStorage.getItem('logData')).id
        ? JSON.parse(sessionStorage.getItem('logData')).id
        : this.$route.query.logId
    };
  },

  created() {
    // 刷新页面保存进度条
    if (sessionStorage.getItem('step')) {
      this.activeStep = JSON.parse(sessionStorage.getItem('step')).activeStep;
      if (this.activeStep === 2) {
        this.onGetAnalyzeConfig();
      }
    }
  },

  methods: {
    /**
     * 添加分析配置
     */
    onAddConfig(type) {
      this.$refs.analyzeConfigCreatorAndEditor.open({
        type: type
      });
    },
    /**
     * 获取字段列表
     */
    async onGetAnalyzeConfig() {
      /**
       * 1.先调接口，展示数据（已经保存过的数据不可删除）
       * 2.如果本地有数据，展示本地数据
       */
      try {
        this.$emit('loading', true);
        if (sessionStorage.getItem('analyzeData')) {
          this.analyzeData = JSON.parse(sessionStorage.getItem('analyzeData'));
        } else {
          const { data } = await reqFetchAnalysis({
            logId: this.logId
          });
          this.analyzeData = data;
        }

        this.onGetDefaultAnalyzeConfig();
      } finally {
        this.$emit('loading', false);
      }
    },
    /**
     * CDN/Mysql 获取默认配置
     */
    async onGetDefaultAnalyzeConfig() {
      // 目前只有 CDN/Mysql 需要加载默认配置
      const isDefault = this.defaultConfigs.some(item => {
        return JSON.parse(sessionStorage.getItem('logType')).name.toLowerCase() === item;
      });

      if (!isDefault) {
        return;
      }

      // 如果已经保存过当前数据源，则不加载默认配置
      const isExitDataSource = await reqFetchDataSource({
        dataSourceId: this.datasource.dataSourceId,
        logId: this.logId
      });
      if (isExitDataSource.data) {
        return;
      }

      // 如果已经保存过数据，再刷新只需要取本地数据，因为删改操作只在前端进行
      if (sessionStorage.getItem('commonAnalyzeData')) {
        this.analyzeData = JSON.parse(sessionStorage.getItem('analyzeData'));
        return;
      }

      this.$emit('loading', true);

      const { data } = await reqFetchCommonConfig({ dataSourceId: this.datasource.dataSourceId });

      this.analyzeData = this.analyzeData.concat(data);

      if (data.length > 0) {
        // 通用配置存本地，以防进行删改操作后，刷新重新加载所有数据
        sessionStorage.setItem('commonAnalyzeData', JSON.stringify(data));
        sessionStorage.setItem('analyzeData', JSON.stringify(this.analyzeData));
      }

      this.$emit('loading', false);
    },
    /**
     * 查询分析配置 - 编辑字段
     */
    onEditAnalyze(scope) {
      this.$refs.analyzeConfigCreatorAndEditor.open({
        type: 'edit',
        data: scope.row,
        index: scope.$index
      });
    },
    /**
     * 查询分析配置 - 编辑子字段
     */
    onEditChildAnalyze(scope, props) {
      this.$refs.analyzeConfigCreatorAndEditor.open({
        type: 'childEdit',
        parentData: scope.row,
        data: props.row,
        index: scope.$index,
        childIndex: props.$index
      });
    },
    /**
     * 查询分析配置 - 添加子字段
     */
    onAddAnalyzeChild(scope) {
      this.$refs.analyzeConfigCreatorAndEditor.open({
        type: 'childCreate',
        data: scope.row,
        index: scope.$index
      });
    },
    /**
     * 查询分析配置 - 删除字段
     */
    async onDeleteAnalyze(scope) {
      if (scope.row.analysisConfigDtoList && scope.row.analysisConfigDtoList.length > 0) {
        this.$alert('请先删除子字段', '警告', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        return;
      }

      try {
        await this.$msgbox({
          title: `警告`,
          message: `确定要删除项目【${scope.row.fieldName}】吗？`,
          type: 'warning',
          showCancelButton: true,
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }
            this.loading = true;
            this.analyzeData.splice(scope.$index, 1);
            sessionStorage.setItem('analyzeData', JSON.stringify(this.analyzeData));
            done();
          }
        });
      } catch (e) {
        if (e === 'cancel') return;
      } finally {
        this.loading = false;
      }
    },
    /**
     * 查询分析配置 - 删除子字段
     */
    async onDeleteChildAnalyze(scope, props) {
      try {
        await this.$msgbox({
          title: `警告`,
          message: `确定要删除项目【${props.row.fieldName}】吗？`,
          type: 'warning',
          showCancelButton: true,
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }
            this.loading = true;

            this.analyzeData[scope.$index].analysisConfigDtoList.splice(props.$index, 1);
            sessionStorage.setItem('analyzeData', JSON.stringify(this.analyzeData));
            done();
          }
        });
      } catch (e) {
        if (e === 'cancel') return;
      } finally {
        this.loading = false;
      }
    },
    /**
     * 分析配置表格是否有子级判断
     */
    getRowClass({ row }) {
      if (row.fieldType && row.fieldType.toLowerCase() === 'json') {
        if (row.analysisConfigDtoList.length < 1) {
          return 'hide-expand';
        }
        return '';
      } else {
        return 'hide-expand';
      }
    },
    /**
     * 查询分析配置 - 字段创建成功后的回调
     */
    async handleAnalyzeSaved({ data, type, index, childIndex }) {
      if (type === 'create') {
        const isRepeatName = this.analyzeData.some(item => {
          return item.fieldName === data.fieldName;
        });

        const isRepeatAlias = this.analyzeData.some(item => {
          return item.fieldName === data.alias;
        });

        if (isRepeatName) {
          this.$message.warning('名称重复，请重新填写');
          return;
        }

        if (isRepeatAlias) {
          this.$message.warning('别名不可以和已经创建的字段名称重复，请重新填写');
          return;
        }

        this.analyzeData.push(data);
      } else if (type === 'edit') {
        this.$set(this.analyzeData, index, data);
      } else if (type === 'childEdit') {
        this.$set(this.analyzeData[index].analysisConfigDtoList, childIndex, data);
      } else if (type === 'childCreate') {
        const isRepeat = this.analyzeData[index].analysisConfigDtoList.some(item => {
          return item.fieldName === data.fieldName;
        });

        if (isRepeat) {
          this.$message.warning('名称重复，请重新填写');
          return;
        }
        // 子级没有 analysisConfigDtoList 字段
        delete data.analysisConfigDtoList;
        this.analyzeData[index].analysisConfigDtoList.push(data);
      }

      this.$refs.analyzeConfigCreatorAndEditor.close();

      // 每次添加或者修改成功，存本地
      sessionStorage.setItem('analyzeData', JSON.stringify(this.analyzeData));
    },
    /**
     * 点击下一步时数据传给父组件
     */
    onSaveData() {
      return this.analyzeData;
    }
  }
};
</script>

<style lang="scss" scoped>
.log-analyze-viewer {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 10px;

  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 14px;
    margin-bottom: 30px;
    font-size: 14px;

    &-text {
      font-weight: bold;
    }
  }

  &-content {
    flex: auto;
    overflow: auto;
  }

  .log-analyze-viewer-table {
    flex: 1;
    overflow: auto;

    &:before {
      display: none;
    }
  }

  /deep/ .el-table__expanded-cell {
    padding: 0;
    border-bottom: 0;

    .el-table__header-wrapper {
      display: none;
    }
  }

  /deep/ .hide-expand {
    .el-table__expand-icon--expanded {
      visibility: hidden;
    }
  }

  /deep/ .hide-expand + tr {
    .el-table__expanded-cell {
      display: none;
    }
  }
}

.el-icon-warning {
  cursor: pointer;
}
</style>
